import { inject, observer } from 'mobx-react'

import AccumulationHome from './AccumulationHome'
import SpendDownHome from './SpendDownHome'
import RetailUpsell from './retail-upsell'

// Redesign is accumulation only, for now; spend-down keeps its original home.
function Home(props) {
  const {
    config: { isSpendown },
    isUnlicensedRetailMember,
  } = props.store

  if (isUnlicensedRetailMember) {
    return <RetailUpsell />
  }

  return isSpendown ? <SpendDownHome /> : <AccumulationHome />
}

export default inject('store')(observer(Home))
